// webComponents.ts
import { createDebugLogger } from './utils/debug';

import './web_components/wcBanner/wcBanner';
import './web_components/wcCase/wcCase';
import './web_components/wcFeaturesBanner/wcFeaturesBanner';
import './web_components/wcSplitBanner/wcSplitBanner';
import './web_components/wcMessageBar/wcMessageBar';
import './web_components/wcScrollingBar/wcScrollingBar';
import './web_components/wcEmergencyMessage/wcEmergencyMessage';
import './web_components/wcNutshell/wcNutshell';
import './web_components/wcProduct/wcProduct';
import './web_components/wcContent/wcContent';
import { WcContent_Utils } from './web_components/wcContent/wcContent_Utils';
import './web_components/wcPanoramic/wcPanoramic';
import './web_components/wcPromo/wcPromo';
import './web_components/wcSpotlightPromo/wcSpotlightPromo';
import './web_components/wcAccordion/wcAccordion';
import './web_components/wcUSPsBar/wcUSPsBar';
import './web_components/wcNotification/wcNotification';
import './web_components/wcSummary/wcSummary';
import './web_components/wcTermsConditionsCopy/wcTermsConditionsCopy';
import './web_components/wcAwards/wcAwards';
import './web_components/wcLinksPanel/wcLinksPanel';
import './web_components/wcTable/wcTable';

//Modals
import './web_components/modals/wcRafModal/wcRafModal';
import './web_components/modals/wcResubscribeModal/wcResubscribeModal';
import './web_components/modals/wcGiftRemindersModal/wcGiftRemindersModal';
import './web_components/modals/wcAgeGateModal/wcAgeGateModal';
import './web_components/modals/wcConsentModal/wcConsentModal';
import './web_components/modals/wcConsentManageModal/wcConsentManageModal';
import './web_components/modals/wcVoucherConflictModal/wcVoucherConflictModal';

// Initialize utilities after all components are loaded
document.addEventListener('DOMContentLoaded', () => {
	WcContent_Utils.initialiseLayoutAdjustments();
});

// Debugging
const debugApp = createDebugLogger('App');
debugApp('All web components and utilities have been statically registered.', 'info');
